export default __webpack_public_path__ + "static/media/nodata.ffc1d325.webp";